import React, { Component } from "react";
import { Link } from "react-router-dom";
import TimeDiff from "../../helpers/TimeDiff";

class PostTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <table className="a-table">
        <thead>
          <tr>
            <td>Username</td>
            <td>Post Title</td>
            <td>Post Type</td>
            <td>Comments</td>
            <td>Upvotes</td>
            <td>Views</td>
            <td>Time Posted</td>
            <td>Delete</td>
          </tr>
        </thead>
        <tbody>
          {this.props.posts.length > 0 &&
            this.props.posts.map(p => (
              <tr key={p.post_id} id={`row${p.post_id}`}>
                <td style={{ textAlign: "left" }}>
                  <Link
                    to={`/user/${p.username.replace(/ /g, "-")}-${p.user_id}`}
                  >
                    {p.username}{" "}
                  </Link>
                </td>
                <td style={{ textAlign: "left" }}>
                  {p.post_type !== "Poll" ? (
                    <Link
                      to={`/post/${p.post_title
                        .replace(/ /g, "-")
                        .replace(/\?/g, "")}-${p.post_id}`}
                    >
                      {p.post_title}
                    </Link>
                  ) : (
                    p.post_title
                  )}
                </td>
                <td>{p.post_type}</td>
                <td>{p.post_comments}</td>
                <td>{p.post_promotes}</td>
                <td>{p.view_count}</td>
                <td>
                  {" "}
                  <TimeDiff date={p.created_at} />{" "}
                </td>
                <td>
                  <button
                    className={
                      parseInt(p.isDeleted) === 0
                        ? `a-table-delete`
                        : `a-table-retrieve`
                    }
                    data-id={p.post_id}
                    data-isdeleted={p.isDeleted}
                    onClick={this.props.postDelete}
                  >
                    {parseInt(p.isDeleted) === 0 ? `Delete` : `Retrieve`}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  }
}

export default PostTable;
